interface RequestAccessState {
	formPostStatus: "" | "pending" | "success" | "failure";
	formPostErrors: Array<{
		code: string;
		message: string;
		data: {
			field: string;
		};
	}>;
}

const INITIAL_REQUEST_ACCESS_STATE: RequestAccessState = {
	formPostStatus: "",
	formPostErrors: [],
};

export default (
	state: RequestAccessState = INITIAL_REQUEST_ACCESS_STATE,
	action: any
): RequestAccessState => {
	switch (action.type) {
		case "REQUEST_ACCESS/POST_FORM/PENDING": {
			return {
				...state,
				formPostStatus: "pending",
				formPostErrors: [],
			};
		}

		case "REQUEST_ACCESS/POST_FORM/FAILURE":
		case "REQUEST_ACCESS/POST_FORM/SUCCESS": {
			return {
				...state,
				formPostStatus: action.data.responseBody.status,
				formPostErrors: action.data.responseBody.errors || [],
			};
		}
	}

	return state;
};

export interface FormValues {
	user_email: string;
	user_id: string;
	user_name: string;
	company_name: string;
	website: string;
	social_media_handles: string;
	project_name: string;
	project_description: string;
	project_platforms: string[];
	industry_vertical: string;
	team_size: number;
	budget: number;
	number_of_users: number;
	launch_date: string;
	captcha_code: string;
}

const REQUEST_ACCESS_FORM_POST_URL: string =
	"https://cwnlovotv1.execute-api.us-east-1.amazonaws.com/prod/blockv-devportal-request-access-form-handler";

export const postForm = (values: FormValues) => dispatch => {
	dispatch({ type: "REQUEST_ACCESS/POST_FORM/PENDING" });

	return fetch(REQUEST_ACCESS_FORM_POST_URL, {
		method: "POST",
		body: JSON.stringify(values),
	})
		.then(res => {
			return res.json().then(data => ({ data, res }));
		})
		.then(({ data, res }) => {
			return dispatch({
				type:
					data.status === "success"
						? "REQUEST_ACCESS/POST_FORM/SUCCESS"
						: "REQUEST_ACCESS/POST_FORM/FAILURE",
				data: {
					responseBody: data,
				},
			});
		})
		.catch(e => {
			console.error("error");
		});
};

export const selectFormPostStatus = state => state.requestAccess.formPostStatus;
export const selectFormErrors = state => state.requestAccess.formPostErrors;



// WEBPACK FOOTER //
// ./src/reducers/request_access.ts